/**
 * GA4（gtag.js）への送出。
 *
 * **外部 SDK は読み込まない**。ホストページに `gtag()` が既にあればそこへ流し、無ければ
 * 黙って何もしない。スクリプトを注入しないので、導入側の CSP `script-src` を広げさせない
 * （M7b で外部プレイヤ SDK を読み込まなかったのと同じ規律）。
 *
 * 存在確認を**送信のたびに**やるのは、gtag のタグが async で後から現れるため。
 * 生成時に 1 度だけ見ると、起動直後のイベントを取りこぼす。
 */
import type { AnalyticsAdapter, AnalyticsContext, AnalyticsEvent } from '../types';
import { GA4_NAMES, ga4Params } from './ga4-names';

type Gtag = (command: 'event', name: string, params: Record<string, unknown>) => void;

export class GtagAdapter implements AnalyticsAdapter {
  constructor(private readonly view: Window) {}

  send(events: readonly AnalyticsEvent[], context: AnalyticsContext): void {
    const gtag = (this.view as unknown as { gtag?: unknown }).gtag;
    if (typeof gtag !== 'function') return;

    for (const event of events) {
      try {
        (gtag as Gtag)(
          'event',
          GA4_NAMES[event.event],
          ga4Params(context.book, event.sid, event.page, event.value),
        );
      } catch {
        /* ホスト側のタグの都合で失敗しても閲覧に影響させない */
      }
    }
  }
}
